import React from 'react';
import PropTypes from 'prop-types';
import styles from './sectionHeader.styles';

const SectionHeader = ({ text, isCustomHeader }) =>
  isCustomHeader ? (
    <span css={styles().sectionHeader}>{text}</span>
  ) : (
    <li key={`section-header-${text}`} css={styles().sectionHeader}>
      {text}
    </li>
  );

SectionHeader.displayName = 'SectionHeader';

SectionHeader.defaultProps = {
  isCustomHeader: false,
  text: ''
};

SectionHeader.propTypes = {
  isCustomHeader: PropTypes.bool,
  text: PropTypes.string
};

export default SectionHeader;
